const weekdayData = (localization) => {
  return[
  {
    id: "1",
    title: localization.openingtimes.monday.title,
    time: localization.openingtimes.monday.status,
    status: "0"
  },
  {
    id: "2",
    title: localization.openingtimes.tuesday.title,
    time: localization.openingtimes.tuesday.status,
    status: "0"
  },
  {
    id: "3",
    title: localization.openingtimes.wednesday.title,
    time: localization.openingtimes.wednesday.status,
    status: "0"
  },
  {
    id: "4",
    title: localization.openingtimes.thursday.title,
    time: localization.openingtimes.thursday.status,
    status: "0"
  },
  {
    id: "5",
    title: localization.openingtimes.friday.title,
    time: localization.openingtimes.friday.status,
    status: "0"
  },
  {
    id: "6",
    title: localization.openingtimes.saturday.title,
    time: localization.openingtimes.saturday.status,
    status: "1"
  },
  {
    id: "7",
    title: localization.openingtimes.sunday.title,
    time: localization.openingtimes.sunday.status,
    status: "1"
  },
]
}

const weekdayData2 = (localization) => {
  return[
  {
    id: "1",
    title: localization.openingtimes2.monday.title,
    time: localization.openingtimes2.monday.status,
    status: "0"
  },
  {
    id: "2",
    title: localization.openingtimes2.tuesday.title,
    time: localization.openingtimes2.tuesday.status,
    status: "0"
  },
  {
    id: "3",
    title: localization.openingtimes2.wednesday.title,
    time: localization.openingtimes2.wednesday.status,
    status: "0"
  },
  {
    id: "4",
    title: localization.openingtimes2.thursday.title,
    time: localization.openingtimes2.thursday.status,
    status: "0"
  },
  {
    id: "5",
    title: localization.openingtimes2.friday.title,
    time: localization.openingtimes2.friday.status,
    status: "0"
  },
  {
    id: "6",
    title: localization.openingtimes2.saturday.title,
    time: localization.openingtimes2.saturday.status,
    status: "1"
  },
  {
    id: "7",
    title: localization.openingtimes2.sunday.title,
    time: localization.openingtimes2.sunday.status,
    status: "1"
  },
]
}

const weekdayData3 = (localization) => {
  return[
  {
    id: "1",
    title: localization.openingtimes3.monday.title,
    time: localization.openingtimes3.monday.status,
    status: "0"
  },
  {
    id: "2",
    title: localization.openingtimes3.tuesday.title,
    time: localization.openingtimes3.tuesday.status,
    status: "0"
  },
  {
    id: "3",
    title: localization.openingtimes3.wednesday.title,
    time: localization.openingtimes3.wednesday.status,
    status: "1"
  },
  {
    id: "4",
    title: localization.openingtimes3.thursday.title,
    time: localization.openingtimes3.thursday.status,
    status: "1"
  },
  {
    id: "5",
    title: localization.openingtimes3.friday.title,
    time: localization.openingtimes3.friday.status,
    status: "1"
  },
  {
    id: "6",
    title: localization.openingtimes3.saturday.title,
    time: localization.openingtimes3.saturday.status,
    status: "1"
  },
  {
    id: "7",
    title: localization.openingtimes3.sunday.title,
    time: localization.openingtimes3.sunday.status,
    status: "1"
  },
]
}

const weekdayData4 = (localization) => {
  return[
  {
    id: "1",
    title: localization.openingtimes4.monday.title,
    time: localization.openingtimes4.monday.status,
    status: "0"
  },
  {
    id: "2",
    title: localization.openingtimes4.tuesday.title,
    time: localization.openingtimes4.tuesday.status,
    status: "0"
  },
  {
    id: "3",
    title: localization.openingtimes4.wednesday.title,
    time: localization.openingtimes4.wednesday.status,
    status: "1"
  },
  {
    id: "4",
    title: localization.openingtimes4.thursday.title,
    time: localization.openingtimes4.thursday.status,
    status: "1"
  },
  {
    id: "5",
    title: localization.openingtimes4.friday.title,
    time: localization.openingtimes4.friday.status,
    status: "1"
  },
  {
    id: "6",
    title: localization.openingtimes4.saturday.title,
    time: localization.openingtimes4.saturday.status,
    status: "1"
  },
  {
    id: "7",
    title: localization.openingtimes4.sunday.title,
    time: localization.openingtimes4.sunday.status,
    status: "1"
  },
  ]
}

  const weekdayData5 = (localization) => {
  return[
  {
    id: "1",
    title: localization.openingtimes5.monday.title,
    time: localization.openingtimes5.monday.status,
    status: "0"
  },
  {
    id: "2",
    title: localization.openingtimes5.tuesday.title,
    time: localization.openingtimes5.tuesday.status,
    status: "0"
  },
  {
    id: "3",
    title: localization.openingtimes5.wednesday.title,
    time: localization.openingtimes5.wednesday.status,
    status: "1"
  },
  {
    id: "4",
    title: localization.openingtimes5.thursday.title,
    time: localization.openingtimes5.thursday.status,
    status: "1"
  },
  {
    id: "5",
    title: localization.openingtimes5.friday.title,
    time: localization.openingtimes5.friday.status,
    status: "1"
  },
  {
    id: "6",
    title: localization.openingtimes5.saturday.title,
    time: localization.openingtimes5.saturday.status,
    status: "1"
  },
  {
    id: "7",
    title: localization.openingtimes5.sunday.title,
    time: localization.openingtimes5.sunday.status,
    status: "1"
  },
]
}

const weekdayData6 = (localization) => {
  return[
  {
    id: "1",
    title: localization.openingtimes6.monday.title,
    time: localization.openingtimes6.monday.status,
    status: "0"
  },
  {
    id: "2",
    title: localization.openingtimes6.tuesday.title,
    time: localization.openingtimes6.tuesday.status,
    status: "1"
  },
  {
    id: "3",
    title: localization.openingtimes6.wednesday.title,
    time: localization.openingtimes6.wednesday.status,
    status: "1"
  },
  {
    id: "4",
    title: localization.openingtimes6.thursday.title,
    time: localization.openingtimes6.thursday.status,
    status: "1"
  },
  {
    id: "5",
    title: localization.openingtimes6.friday.title,
    time: localization.openingtimes6.friday.status,
    status: "1"
  },
  {
    id: "6",
    title: localization.openingtimes6.saturday.title,
    time: localization.openingtimes6.saturday.status,
    status: "1"
  },
  {
    id: "7",
    title: localization.openingtimes6.sunday.title,
    time: localization.openingtimes6.sunday.status,
    status: "1"
  },
]
}

const weekdayData7 = (localization) => {
  return[
  {
    id: "1",
    title: localization.openingtimes7.monday.title,
    time: localization.openingtimes7.monday.status,
    status: "0"
  },
  {
    id: "2",
    title: localization.openingtimes7.tuesday.title,
    time: localization.openingtimes7.tuesday.status,
    status: "0"
  },
  {
    id: "3",
    title: localization.openingtimes7.wednesday.title,
    time: localization.openingtimes7.wednesday.status,
    status: "0"
  },
  {
    id: "4",
    title: localization.openingtimes7.thursday.title,
    time: localization.openingtimes7.thursday.status,
    status: "0"
  },
  {
    id: "5",
    title: localization.openingtimes7.friday.title,
    time: localization.openingtimes7.friday.status,
    status: "0"
  },
  {
    id: "6",
    title: localization.openingtimes7.saturday.title,
    time: localization.openingtimes7.saturday.status,
    status: "1"
  },
  {
    id: "7",
    title: localization.openingtimes7.sunday.title,
    time: localization.openingtimes7.sunday.status,
    status: "1"
  },
]
}

const weekdayData8 = (localization) => {
  return[
  {
    id: "1",
    title: localization.openingtimes8.monday.title,
    time: localization.openingtimes8.monday.status,
    status: "0"
  },
  {
    id: "2",
    title: localization.openingtimes8.tuesday.title,
    time: localization.openingtimes8.tuesday.status,
    status: "0"
  },
  {
    id: "3",
    title: localization.openingtimes8.wednesday.title,
    time: localization.openingtimes8.wednesday.status,
    status: "1"
  },
  {
    id: "4",
    title: localization.openingtimes8.thursday.title,
    time: localization.openingtimes8.thursday.status,
    status: "1"
  },
  {
    id: "5",
    title: localization.openingtimes8.friday.title,
    time: localization.openingtimes8.friday.status,
    status: "1"
  },
  {
    id: "6",
    title: localization.openingtimes8.saturday.title,
    time: localization.openingtimes8.saturday.status,
    status: "1"
  },
  {
    id: "7",
    title: localization.openingtimes8.sunday.title,
    time: localization.openingtimes8.sunday.status,
    status: "1"
  },
]
}
  const weekdayData9 = (localization) => {
  return[
  {
    id: "1",
    title: localization.openingtimes9.monday.title,
    time: localization.openingtimes9.monday.status,
    status: "0"
  },
  {
    id: "2",
    title: localization.openingtimes9.tuesday.title,
    time: localization.openingtimes9.tuesday.status,
    status: "0"
  },
  {
    id: "3",
    title: localization.openingtimes9.wednesday.title,
    time: localization.openingtimes9.wednesday.status,
    status: "0"
  },
  {
    id: "4",
    title: localization.openingtimes9.thursday.title,
    time: localization.openingtimes9.thursday.status,
    status: "1"
  },
  {
    id: "5",
    title: localization.openingtimes9.friday.title,
    time: localization.openingtimes9.friday.status,
    status: "0"
  },
  {
    id: "6",
    title: localization.openingtimes9.saturday.title,
    time: localization.openingtimes9.saturday.status,
    status: "1"
  },
  {
    id: "7",
    title: localization.openingtimes9.sunday.title,
    time: localization.openingtimes9.sunday.status,
    status: "1"
  },
]
}
const weekdayData10 = (localization) => {
  return[
  {
    id: "1",
    title: localization.openingtimes10.monday.title,
    time: localization.openingtimes10.monday.status,
    status: "0"
  },
  {
    id: "2",
    title: localization.openingtimes10.tuesday.title,
    time: localization.openingtimes10.tuesday.status,
    status: "0"
  },
  {
    id: "3",
    title: localization.openingtimes10.wednesday.title,
    time: localization.openingtimes10.wednesday.status,
    status: ""
  },
  {
    id: "4",
    title: localization.openingtimes10.thursday.title,
    time: localization.openingtimes10.thursday.status,
    status: "1"
  },
  {
    id: "5",
    title: localization.openingtimes10.friday.title,
    time: localization.openingtimes10.friday.status,
    status: "1"
  },
  {
    id: "6",
    title: localization.openingtimes10.saturday.title,
    time: localization.openingtimes10.saturday.status,
    status: "1"
  },
  {
    id: "7",
    title: localization.openingtimes10.sunday.title,
    time: localization.openingtimes10.sunday.status,
    status: "1"
  },
]
}

export {weekdayData, weekdayData2, weekdayData3, weekdayData4, weekdayData5, weekdayData6, weekdayData7, weekdayData8, weekdayData9, weekdayData10}